<template>
    <div class="order_product">
        <div class="order_title">皇家行前订产品</div>
        <div v-if="!pcpOrder || pcpOrder.orderStatus != 1 || pcpOrder.shopCartItems.length == 0">
            <div class="order_notice">
                <div class="">您尚未预订任何皇家行前订产品</div>

            </div>
            <div class="continue_order"><a @click="goToPcp" style="text-decoration: none;color: #282b2c">立即预订</a></div>
            <div class="order_notice order_notice_small">
                <div class="">注：皇家行前订产品价格不包含在船票费用中，将于登船后支付。</div>
            </div>
        </div>
        <div v-else>
            <div class="order_person">预定支付人：{{majorGuestName}}</div>
            <div class="super_net" v-for="(pcpOrder, i) in pcpOrderItems" :key="('pcpOrder_' + i)">
                <div class="super_title">{{pcpOrder.category}}</div>
                <ul class="super_detail">
                    <li  v-for="(item, j) in pcpOrder.items" :key="('pcpItem_' + i + '_'+ j)">
                        <img class="f-fl" :src="item.thumbnailIcon" :alt="item.thumbnailIconAlt">
                        <div class="super_content f-fl">
                            <div class="super_t">{{item.name}}</div>

                            <div class="super_com" v-if="item.priceByRouteNights || item.priceByRouteDays">
                                <span class="super_title_text">预定时段 </span>：
                                <span class="super_bold">全程</span>
                            </div>

                            <div class="super_com" v-else-if="item.bundleType==1">
                                <span v-if="hasShipDate(item)">
                                    <span class="super_title_text">预定时段 </span>： <span>{{item.shipDate}} </span>
                                    <span class="super_bold" v-if="hasTimeSlot(item)">
                                        {{item.timeSlotStartTime}} - {{item.timeSlotEndTime}}
                                    </span>
                                </span>
                            </div>

                            <div class="super_com" v-else-if="item.bundleType==2">
                                <div class="checkOut-project-cell-txt2">
                                    <span class="super_title_text">预定时段 </span>：
                                </div>
                                <div class="packageItems">
                                    <div v-for="(packageItem) in getPackageItems(item.productId, item.orderDetailId)" :key="('package_' + packageItem.orderDetailId)">
                                        <div>{{packageItem.name}}</div>
                                        <div v-if="hasShipDate(packageItem)">
                                            <p>
                                                {{packageItem.shipDate}}
                                                <span v-if="hasTimeSlot(packageItem)">
                                                    {{packageItem.timeSlotStartTime}} - {{packageItem.timeSlotEndTime}}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="super_com"><span class="super_title_text">数量 </span>： <span class="super_bold">{{item.qty}}</span></div>
                            <div v-if="item.pcpCartItemBookingInfos && item.pcpCartItemBookingInfos.length > 0">
                                <div class="super_com join_person" v-for="(bookingInfo) in getPcpBookingInfos(item)"
                                    :key="('bookingInfo_' + bookingInfo.bookingId)">
                                    <span class="super_title_text">参与人</span>：
                                    <span class="super_shipOrder super_bold" >
                                    船票订单号：{{bookingInfo.bookingId}} | 房间号：{{bookingInfo.stateroomNumber == 'GTY' ? '航司分配': bookingInfo.stateroomNumber}}
                                    <br> {{bookingInfo.guests.join(',')}}
                                    </span>
                                </div>
                            </div>
                            <!-- <div class="super_com join_person">
                                参<span style="margin: 0 7px;">与</span>人：
                                <span class="super_shipOrder super_bold">船票订单号：1357318 | 房间号：8713<br> TEST TEST,DA CEYI</span>
                            </div> -->

                            <div class="super_com">
                                <span class="super_title_text">单价</span>：
                                <span class="super_bold">{{item.priceDiscounted.toFixed("2")}} {{item.priceByRouteDays || item.priceByRouteNights ? '美元/航次/人' : item.priceUnit}}</span>
                            </div>
                            <div class="super_com" v-if="item.unitDiscountedServiceCharge > 0 && item.bundleType != 2 && item.hasServiceCharge">
                                <span class="tiny">含服务费：{{item.unitDiscountedServiceCharge.toFixed("2")}} 美元</span>
                            </div>
                        </div>
                        <div class="cost_total">费用总计 <span class="tiny">{{(item.priceDiscountedTotal).toFixed("2")}}美元</span></div>
                    </li>
                </ul>
            </div>
            <div class="order_notice">
                <div class="f-fl">注: 皇家行前订产品价格不包含在船票价格中，将于船上支付</div>
                    <div class="f-fr">合计: <span class="tiny_span" style="color: #ff3022">{{pcpOrder.priceDiscountedTotal.toFixed(2)}}美元</span></div>
                    <div class="f-fr"><span class="tiny_span" style="color: #ff3022">(含服务费: &nbsp; {{pcpOrder.unitDiscountedServiceChargeTotal.toFixed(2)}}美元)</span></div>
            </div>
            <div class="continue_order"><a @click="goToPcp" style="text-decoration: none;color: #282b2c">继续预定</a></div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "BookingDetailPcp",
    props: {
        pcpOrder: {
            type: Object
        },
        booking: {
            type: Object
        }
    },
    data () {
        return {
          categories: [ 'WiFi套餐', '环球食刻', '畅享欢饮', '舞台巨制', '尊享服务', '海上潮玩', 'SPA', '光影典藏', '岸上观光']
        }
    },
    methods: {
        getPackageItems (productId, orderDetailId) {
            return this.packages.filter(r=>r.packageId == productId && r.packageOrderDetailId == orderDetailId)
        },
        hasShipDate (orderItem) {
            return orderItem.shipDate && orderItem.shipDate.length > 0 && orderItem.shipDate != '1753-01-01'
        },
        hasTimeSlot (orderItem) {
            return orderItem.timeSlotStartTime && orderItem.timeSlotStartTime.length> 0
            && orderItem.timeSlotEndTime && orderItem.timeSlotEndTime.length > 0
        },
        getPcpBookingInfos (orderItem) {
            let bookingInfos = []
            if (!orderItem.pcpCartItemBookingInfos || orderItem.pcpCartItemBookingInfos.length == 0) return []
            orderItem.pcpCartItemBookingInfos.forEach((item) => {
                let bookingInfo = bookingInfos.find(r=>r.bookingId == item.bookingId)
                if (bookingInfo) {
                    bookingInfo.guests.push(item.guestName)
                } else {
                    bookingInfos.push({
                        bookingId: item.bookingId,
                        stateroomNumber: item.stateroomNumber,
                        guests: [item.guestName]
                    })
                }
            })
            return bookingInfos
        },
        async goToPcp () {
            const { data } = await api.user.getPcpToken()
            let token = ""
            if (data && data.length > 0) {
                token = data
            }
            // 更新为encBookingId
            const url = `${process.env.VUE_APP_PCP_URL}/Rccl.Pcp/Home/Index?token=${token}`
            +`&sailDate=${this.booking.sailDate}&shipCode=${this.booking.shipCode}&encBookingId=${this.booking.encBookingId}`
            location.href = url
        }
    },
    computed: {
        packages () {
            return this.pcpOrder.packages || []
        },
        majorGuest () {
            if (!this.booking || !this.booking.bookingGuests) return {}
            return this.booking.bookingGuests.find(r=>r.id == this.pcpOrder.majorGuestId)
        },
        majorGuestName () {
            let guestName = ''
            if (this.majorGuest.chineseLastName && this.majorGuest.chineseLastName.length > 0
            && this.majorGuest.chineseFirstName && this.majorGuest.chineseFirstName.length > 0) {
                guestName = `${this.majorGuest.chineseLastName}${this.majorGuest.chineseFirstName} `
            }
            guestName += `${this.majorGuest.pinYinLastName} ${this.majorGuest.pinYinFirstName}`
            return guestName
        },
        pcpOrderItems () {
            if (!this.pcpOrder || !this.pcpOrder.shopCartItems || this.pcpOrder.shopCartItems.length == 0) {
                return []
            }
            let items = []
            let packageItemIds = []
            if (this.pcpOrder.packages) {
                packageItemIds = this.pcpOrder.packages.map(r=>r.orderDetailId)
            }
            this.categories.forEach((category) => {
                let categoryName = category + ''
                const orderItems = this.pcpOrder.shopCartItems
                .filter(r=>r.categoryName == categoryName && packageItemIds.indexOf(r.orderDetailId) < 0)
                if (orderItems.length > 0) {
                    items.push({
                        category,
                        items: orderItems
                    })
                }
            })
            return items
        },
        totalPrice () {
            let totalPrice = 0
            this.pcpOrderItems.forEach((orderItem) => {
                if (orderItem.items) {
                    orderItem.items.forEach((item) => {
                        totalPrice += item.priceDiscounted * item.qty
                    })
                }
            })

            return totalPrice
        },
        totalServiceCharges () {
            let totalPrice = 0
            this.pcpOrderItems.forEach((orderItem) => {
                if (orderItem.items) {
                    orderItem.items.forEach((item) => {
                        if (item.hasServiceCharge) {
                            totalPrice += item.priceServiceCharge * item.qty
                        }
                    })
                }
            })
            return totalPrice
        }
    }
}
</script>

<style lang="less" scoped>
.order_product {
    width: 100%;
    background-color: #fff;
    padding: 20px 20px 20px;
    overflow: hidden;
    border-top: 3px solid #e5f4ff;
    margin-bottom: 12px;
    .order_title {
        font-size: 22px;
        font-weight: 400;
        color: #282b2c;
    }
    .order_notice {
        overflow: hidden;
        margin-top: 25px;
        text-align: center;
    }
    .order_notice_small {
        font-size: 12px;
    }
    .continue_order {
        width: 148px;
        height: 40px;
        background: #fbc500;
        font-size: 14px;
        line-height: 40px;
        text-align: center;
        color: #282b2c;
        margin: 12px auto 0 auto;
        cursor: pointer;
    }
    .order_person {
        margin: 10px 0 20px 0;
        background: #f3f6f8;
        text-indent: 8px;
        font-size: 14px;
        padding: 8px 0;
    }
    .super_net {
        margin-bottom: 10px;
    }
    .super_title {
        background: #f3f6f8;
        text-indent: 20px;
        font-size: 20px;
        font-weight: 400;
        color: #282b2c;
        padding: 10px 0;
        border: 1px solid #d3dadd;
    }
    .super_detail {
        padding: 0 20px;
        border: 1px solid #d3dadd;
        border-top: 0;
        li {
            border-bottom: 1px solid #d3dadd;
            overflow: hidden;
            padding: 20px 0;
            position: relative;
            .cost_total {
                position: absolute;
                top: 82px;
                right: 0;
            }
            .tiny {
                color: #ff3022;
                margin-left: 52px;
            }
        }
        li:last-child {
            border-bottom: 0;
        }
        img {
            width: 220px;
        }
        .super_content {
            margin-left: 18px;
            .super_t {
                color: #282b2c;
                font-weight: 400;
                font-size: 16px;
                margin-bottom: 10px;
            }
            .super_com {
                margin-bottom: 10px;
                clear: both;
                .super_title_text {
                    display: inline-block;
                    width: 58px;
                    text-align: justify;
                    text-align-last: justify;
                }
            }
            .checkOut-project-cell-txt2 {
                display: inline-block;
                vertical-align: top;
            }
            .packageItems {
                position: relative;
                margin-left: 5px;
                font-weight: 400;
                color: #282b2c;
                display: inline-block;
                vertical-align: top;
            }
            .super_bold {
                font-weight: 400;
                color: #282b2c;
            }
            .join_person {
                width: 360px;
                display: flex;
            }
        }
    }
}
</style>
